import * as t from 'io-ts';
import { DateFromUnixTime } from 'io-ts-types';

const subscriptionItem = t.type({
  amount: t.number,
  freeQuantity: t.union([t.number, t.null]),
  itemPriceId: t.string,
  itemType: t.string,
  quantity: t.number,
  trialEnd: t.union([t.number, t.null]),
  unitPrice: t.number,
});

const subscription = t.type({
  id: t.string,
  currencyCode: t.string,
  currentTermStart: DateFromUnixTime,
  currentTermEnd: DateFromUnixTime,
  deleted: t.boolean,
  dueInvoicesCount: t.number,
  hasScheduledChanges: t.boolean,
  interval: t.string,
  isFree: t.boolean,
  isPastDue: t.boolean,
  nextChargeAt: t.union([t.number, t.null]),
  createdAt: t.number,
  startedAt: t.number,
  status: t.string,
  trialEnd: t.union([t.number, t.null]),
  trialStart: t.union([t.number, t.null]),
  updatedAt: t.union([t.number, t.null]),
  hasPaymentMethod: t.boolean,
  subscriptionItems: t.array(subscriptionItem),
  isEnterprise: t.union([t.boolean, t.null]),
  isCancellationScheduled: t.union([t.boolean, t.undefined]),
});

export const subscriptionCodec = subscription;
export const subscriptionItemCodec = subscriptionItem;
